import { useParams } from "react-router-dom";
import { blogs } from "../data/blogs";
import ReactMarkdown from "react-markdown";

export default function BlogDetail() {
  const { id } = useParams();
  const blog = blogs.find((b) => b.id === id);

  if (!blog) {
    return <div className="p-4 text-red-500 text-lg">Blog not found.</div>;
  }

  return (
    <div className="p-4 max-w-3xl mx-auto">
      {blog.image && (
        <img
          src={blog.image}
          alt={blog.title}
          className="w-full h-64 object-cover rounded-xl mb-6"
        />
      )}

      <h1 className="text-4xl font-bold mb-2">{blog.title}</h1>
      <p className="text-gray-500 mb-6">{blog.date}</p>

      <div className="text-lg leading-relaxed space-y-4">
        <ReactMarkdown>{blog.content}</ReactMarkdown>
      </div>
    </div>
  );
}
